'use client'

import { Form as AriaKitForm } from '@ariakit/react'
import styled from 'styled-components'

/**
 * Styled Ariakit Form component.
 * Use with a form store created via `useFormStore`.
 *
 * @example
 * const form = useFormStore({ defaultValues: { email: '' } })
 * form.useSubmit(async (state) => { ... })
 *
 * <Form store={form} noValidate>
 *   <FormInput name="email" type="email" />
 * </Form>
 */
export const Form = styled(AriaKitForm)``
